import React from 'react';
import { Box, Link, Stack } from '@chakra-ui/react';
import { FiChevronRight, FiMail } from 'react-icons/fi';
import { BsGrid, BsBook } from 'react-icons/bs';

interface MobileMainMenuProps {
  isVisible: boolean;
  onOpenSubmenu: (menu: 'top-features' | 'learn-more') => void;
  onCloseMenu: () => void;
}

const MobileMainMenu: React.FC<MobileMainMenuProps> = ({ isVisible, onOpenSubmenu, onCloseMenu }) => {
  return (
    <Box
      py={6}
      px={4}
      transition="all 0.3s ease"
      transform={isVisible ? 'translateX(0)' : 'translateX(-100%)'}
      opacity={isVisible ? 1 : 0}
      position={isVisible ? 'relative' : 'absolute'}
      width="100%"
      top={0}
      left={0}
      role="menu"
      aria-label="Main navigation menu"
    >
      <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
        <defs>
          <linearGradient id="gradient-purple-pink" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8B5CF6" />
            <stop offset="100%" stopColor="#EC4899" />
          </linearGradient>
          <linearGradient id="gradient-indigo-teal" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#6366F1" />
            <stop offset="100%" stopColor="#14B8A6" />
          </linearGradient>
        </defs>
      </svg>

      <Stack gap={1} as="ul" listStyleType="none">
        <Box as="li" role="menuitem">
          <Box
            as="button"
            onClick={() => onOpenSubmenu('top-features')}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            py={2}
            px={4}
            borderRadius="2xl"
            transition="all 0.2s ease"
            _hover={{ bg: 'gray.50' }}
            aria-haspopup="true"
          >
            <Box display="flex" alignItems="center" gap={3}>
              <Box flexShrink={0} aria-hidden="true">
                <BsGrid size={24} style={{ fill: 'url(#gradient-purple-pink)' }} />
              </Box>
              <Box textAlign="left">
                <Box fontFamily="lato" fontWeight="bold" fontSize="1rem" color="#13131B">
                  Top Features
                </Box>
                <Box fontFamily="lato" fontSize="0.75rem" color="gray.500">
                  Explore what Olympiq offers
                </Box>
              </Box>
            </Box>
            <FiChevronRight size={20} color="#13131B" aria-hidden="true" />
          </Box>
        </Box>

        <Box as="li" role="menuitem">
          <Box
            as="button"
            onClick={() => onOpenSubmenu('learn-more')}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            py={2}
            px={4}
            borderRadius="2xl"
            transition="all 0.2s ease"
            _hover={{ bg: 'gray.50' }}
            aria-haspopup="true"
          >
            <Box display="flex" alignItems="center" gap={3}>
              <Box flexShrink={0} aria-hidden="true">
                <BsBook size={24} style={{ fill: 'url(#gradient-indigo-teal)' }} />
              </Box>
              <Box textAlign="left">
                <Box fontFamily="lato" fontWeight="bold" fontSize="1rem" color="#13131B">
                  Learn More
                </Box>
                <Box fontFamily="lato" fontSize="0.75rem" color="gray.500">
                  Guides and resources
                </Box>
              </Box>
            </Box>
            <FiChevronRight size={20} color="#13131B" aria-hidden="true" />
          </Box>
        </Box>

        <Box as="li" role="menuitem">
          <Link
            href="/contact-us"
            onClick={onCloseMenu}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            width="100%"
            p={4}
            mt={3}
            borderRadius="2xl"
            bgGradient="to-r"
            gradientFrom="#13131B"
            gradientTo="#374151"
            boxShadow="0 4px 15px rgba(19, 19, 27, 0.4)"
            transition="all 0.2s ease"
            _hover={{ transform: 'scale(1.02)', boxShadow: '0 6px 20px rgba(19, 19, 27, 0.5)', textDecoration: 'none' }}
          >
            <Box display="flex" alignItems="center" gap={3}>
              <Box flexShrink={0} aria-hidden="true">
                <FiMail size={24} color="white" />
              </Box>
              <Box textAlign="left">
                <Box fontFamily="lato" fontWeight="bold" fontSize="1rem" color="white">
                  Contact Us
                </Box>
                <Box fontFamily="lato" fontSize="0.75rem" color="rgba(255,255,255,0.7)">
                  Get in touch with our team
                </Box>
              </Box>
            </Box>
            <FiChevronRight size={20} color="white" aria-hidden="true" />
          </Link>
        </Box>
      </Stack>
    </Box>
  );
};

export default MobileMainMenu;
